import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import UserBookingMenu from './partials/UserBookingMenu';
import { itemService, globalService as gs } from '../../../../common/services';
import moment from 'moment-timezone';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import Rating from '@material-ui/lab/Rating';
import { CancelBookingDialog, DisputBookingDialog, RatingFormDialog } from '../../Common';
import Messenger from '../../Messanger';
import { alertSelectors } from '../../../../common/redux/selectors';
import { confirmAlert } from 'react-confirm-alert';
import { VideoChat } from '../../TwilioVideo';
import { orderStatus } from '../../../../helpers';

class UserBookingView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
            parent: null,
            tutor: null,
            orders: null,
            extra: null,
            loading: false,
            recipients: false,
            joinLoading: false,
            ratingOpen: false,
            cancelOpen: false,
            disputOpen: false,
            activeKey: null,
        };
    }

    componentDidMount() {
        const { match, authentication } = this.props;
        const { user } = authentication.authentication
        let user_id = user.id;
        const item_id = match && match.params.id;
        gs.db.ref(`User/${user_id}/is_notified`)
        .on("value", (snap) => {
            //console.log('snapsnapsnapsnap', snap);
            this.loadBooking({order_id: item_id});
        });


    }

    loadBooking = (params = null) => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.booking("GET", null, params).then(data => {
            if(data.code) {
                const item = data.model;
                const parent = item && item.actionBy;
                const tutor = item.userCatalogOrdersItems[0].user;
                const orders = item.userCatalogOrdersItems[0];
                const recipients = item.recipients;
                const extra = (orders.extra) ? JSON.parse(orders.extra) : null;
                this.setState({ item, parent, tutor, orders, extra, recipients, loading: false, activeKey: item.message_key});
            }
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    closeRating = (event) => {
        if(event) {
            const { match } = this.props;
            const item_id = match && match.params.id;
            this.loadBooking({order_id: item_id});
        }
        this.setState({ratingOpen: false});
    }

    joinMeeting = (params = null, key = 'start') => {
        const { dispatch } = this.props;
        confirmAlert({
            title: `Please confirm to ${key}`,
            message: `Are you sure to ${key} this session`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => console.log('No')
                },
                {
                    label: 'Yes',
                    onClick: () => {
                        this.setState({ joinLoading: true });
                        itemService.meeting("POST", {item_id: params.order_id}, {item_id: params.order_id, status: key}).then(data => {
                            this.setState({joinLoading: false});
                            if(data.code) {
                                const item = data.model;
                                const extra = (item.extra) ? JSON.parse(item.extra) : null;
                                this.setState({extra: extra});
                            } else {
                                dispatch(alertSelectors.error(data));
                            }
                        })
                        .catch(exception => {
                            gs.showErrors(dispatch, exception, alertSelectors);
                            this.setState({joinLoading: false});
                        });
                    }
                }
            ]
        });
    }

    updateState = (item) => {
        const parent = item && item.actionBy;
        const tutor = item.userCatalogOrdersItems[0].user;
        const orders = item.userCatalogOrdersItems[0];
        const recipients = item.recipients;
        const extra = (orders.extra) ? JSON.parse(orders.extra) : null;
        const notify = recipients.map(item => { return item.user_id });
        gs.isNotified(notify);
        this.setState({item, parent, tutor, orders, recipients, extra});
    }

    bookingComplete = (order, status = orderStatus.ORDER_COMPLETE) => {
        const { dispatch } = this.props;
        const params = {
            comment: (status === orderStatus.ORDER_COMPLETE) ? 'Booking Completed By Parent' : 'Dispute Created',
            status: status,
        }
        confirmAlert({
            //title: `Please confirm to booking completed`,
            message: `Are you sure to accept to completed this session`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => console.log('No')
                },
                {
                    label: 'Yes',
                    onClick: () => {
                        this.setState({completeLoading: true});
                        itemService.orderComment("POST", {UserCatalogOrders: params}, {order_id: order.order_id, key: 'status'}).then(data => {
                            if(data.code) {
                                const item = data.model;
                                const parent = item && item.actionBy;
                                const tutor = item.userCatalogOrdersItems[0].user;
                                const orders = item.userCatalogOrdersItems[0];
                                const recipients = item.recipients;
                                const extra = (orders.extra) ? JSON.parse(orders.extra) : null;
                                const notify = recipients.map(item => { return item.user_id });
                                gs.isNotified(notify);
                                this.setState({item, parent, tutor, orders, recipients, extra, completeLoading: false});
                                const message = 'You have successfully accept to completed this session.';
                                dispatch(alertSelectors.success(message));
                            } else {
                                dispatch(alertSelectors.error('Action not perform'));
                            }
                        })
                        .catch(exception => {
                            gs.showErrors(dispatch, exception, alertSelectors);
                            this.setState({completeLoading: false});
                        });
                    }
                }
            ]
        });
    }

    closeDisput = (e) => {
        if(e !== false) {
            //this.updateState(e);
            const { match } = this.props;
            const item_id = match && match.params.id;
            this.loadBooking({order_id: item_id});
        }
        this.setState({ disputOpen: false});
    }

    closeCancel = (e) => {
        if(e !== false) {
            this.updateState(e);
        }
        this.setState({ cancelOpen: false});
    }


    render() {
        const { item, parent, tutor, orders, extra, ratingOpen, activeKey, cancelOpen, disputOpen } = this.state;
        
        let showCancel = true;
        showCancel = showCancel && (item && item.status !== orderStatus.ORDER_CANCEL);

        let orderLessTime = (orders && orders.start_time) - (3600 * 12);
        let startTime = (orders && orders.start_time);
        let currentTime = moment(new Date()).format('X');
        let differTime = (startTime - currentTime);
        showCancel = showCancel && ((differTime >= (12*3600)) && (extra && extra.status !== 'completed') && (extra && extra.status !== 'join') && (extra && extra.status !== 'create') && (extra && extra.status !== 'deleted') && (parseInt(item && item.status) !== orderStatus.ORDER_COMPLETE));


        let showRating = true;
        showRating = showRating && (item && item.status === orderStatus.ORDER_COMPLETED);
        showRating = showRating && orders && orders.review === null;
        showRating = showRating && ((item && item.updated_at) + (3600 * 12) > (item && item.updated_at));

        let userCatalogOrdersDisputes = item && item.userCatalogOrdersDisputes;

        let showDispute = false;
        showDispute = (userCatalogOrdersDisputes && userCatalogOrdersDisputes === false);

        let activeClass = '';

        switch (item && item.status) {
            case orderStatus.ORDER_PENDING:
                activeClass = 'UserBooking';
                if(item.is_dispute === 1) {
                    activeClass = 'DisputedSessions';
                }
                break;
            case orderStatus.ORDER_COMPLETE:
                activeClass = 'UserSessions';
                if(item.is_dispute === 1) {
                    activeClass = 'DisputedSessions';
                }
                break;
            case orderStatus.STATUS_PAYMENT_TRANSFER:
                activeClass = 'UserSessions';
                if(item.is_dispute === 1) {
                    activeClass = 'DisputedSessions';
                }
                break;
            case orderStatus.ORDER_CANCELLED:
                activeClass = 'CancelledSessions';
                if(item.is_dispute === 1) {
                    activeClass = 'DisputedSessions';
                }
                break;

            case orderStatus.ORDER_MARK_AS_COMPLETE:
                if(item.is_dispute === 1) {
                    activeClass = 'DisputedSessions';
                }
                break;
            case orderStatus.ORDER_DISPUTE:
                if(item.is_dispute === 1) {
                    activeClass = 'DisputedSessions';
                }
                break;
            default:
                activeClass = '';
                break;
        }

        var currentDate = new Date();
        var currentDateTime = parseInt(currentDate.getTime() / 1000);

        return (<DashboardLayout activeClass="UserBooking">
            {(orders && orders) && <RatingFormDialog open={ratingOpen} onClose={this.closeRating} itemData={orders} tutor={tutor} />}
            {(item && item) && <>
                <DisputBookingDialog open={disputOpen} onClose={this.closeDisput} item={item && item} />
                <CancelBookingDialog open={cancelOpen} onClose={this.closeCancel} item={item && item} />
            </>}

            <section className="dashboard messages-page">
                <div id="msg-left">
                    <div className="row">
                        <UserBookingMenu activeClass={activeClass} />
                        <div className="col-md-12">
                            <div className="post-box">
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 col-12 mb-4">
                                        <div className="media">
                                            <div className="image">
                                                <p className="text-primary ml-3 font-weight-bold mb-2">Tutor</p>
                                                <img className="mr-4 img-circle" src={tutor && tutor.avatar} alt="pic" width="70" height="70"/>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-4"><Link to={`/tutor/view/${tutor && tutor.id}`}>{tutor && tutor.name}</Link></h5>
                                                <div className="rating mb-2">
                                                    <span className="star">
                                                        {(tutor && tutor.rating_avg) && <Rating name="size-medium" value={parseInt(tutor.rating_avg)} readOnly />}
                                                    </span>
                                                    <span> ({tutor && tutor.rating_avg}) {tutor && tutor.count_rating} Ratings</span>
                                                </div>
                                                <div className="location">
                                                    <i className="fas fa-map-marker-alt"></i> {tutor && tutor.countryCode && tutor.countryCode.name}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-12 mb-4">
                                        <div className="media">
                                            <div className="image">
                                                <p className="text-primary ml-3 font-weight-bold mb-2">Parent</p>
                                                <img className="mr-4 img-circle" src={parent && parent.avatar && parent.avatar.thumb} alt="pic" width="70" height="70"/>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-5">{parent && parent.name}</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-9 col-lg-12 col-12 mb-4">
                                        <p className="text-primary font-weight-bold">Session Details</p>
                                        <div className="row">
                                            <div className="col-xl-5 col-lg-12 col-12">
                                                <div className="inform">
                                                    <div className="d-flex">
                                                        <label>Date :</label>
                                                        <div className="date">
                                                            {moment(orders && orders.start_time * 1000).format('MM/DD/YYYY')}<br/> {moment(orders && orders.start_time * 1000).format('LT')} - {moment(orders && orders.start_time * 1000).add(60, 'minutes').format('LT')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-12 col-6">
                                                <div className="inform">
                                                    <div className="d-flex">
                                                        <label>Cost :</label>
                                                        <div className="date">
                                                            ${orders && orders.price}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="inform">
                                                    <div className="d-flex">
                                                        <label>Duration :</label>
                                                        <div className="date">
                                                            60 min
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-lg-12 col-12">
                                                <div className="sub">
                                                    <button className="btn btn-light">{orders && orders.catalog && orders.catalog.title}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-12 col-12 mb-4">
                                        <p className="text-primary font-weight-bold">Payment Status</p>
                                        <div className="d-flex justify-content-between">
                                            <div className="date">Paid</div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <div className="videos-start">
                                            {((extra && extra.links) && (extra && extra.status === 'create')) && (item && item.status !== orderStatus.ORDER_COMPLETE) && (parseInt(item && item.status) !== orderStatus.ORDER_CANCELLED) && <>
                                                <LaddaButton type="button" className="btn btn-primary mr-3" loading={this.state.joinLoading} data-style={EXPAND_RIGHT} onClick={() => this.joinMeeting(orders && orders, 'join')}>Start Session</LaddaButton>
                                            </>}

                                            {((extra && extra.links) && ((extra && extra.status === 'join'))) && (item && item.status !== orderStatus.ORDER_COMPLETE) && (parseInt(item && item.status) !== orderStatus.ORDER_CANCELLED) && <>
                                                <a className="btn btn-primary" href={extra.links[gs.identity.user.username]} target="_blank">Go to Session</a>
                                            </>}
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-between">
                                            <div className="session">

                                                {((parseInt(item && item.status) === orderStatus.ORDER_MARK_AS_COMPLETE) && (userCatalogOrdersDisputes === false)) &&
                                                <LaddaButton type="button" className="btn btn-primary mr-3" loading={this.state.completeLoading} data-style={EXPAND_RIGHT} onClick={() => this.bookingComplete(orders && orders, orderStatus.ORDER_COMPLETE)}>Accept</LaddaButton> 
                                                }

                                                {((moment(orders && orders.start_time) < moment(currentDateTime)) && (userCatalogOrdersDisputes === false)) && (parseInt(item && item.status) !== orderStatus.ORDER_CANCELLED) && (parseInt(item && item.status) != orderStatus.ORDER_COMPLETE) &&
                                                <LaddaButton type="button" className="btn btn-primary" onClick={() => this.setState({ disputOpen: true })}>Dispute</LaddaButton>
                                                }

                                                {(parseInt(item && item.status) === orderStatus.ORDER_COMPLETE || parseInt(item && item.status) === orderStatus.STATUS_PAYMENT_TRANSFER) && <span className="badge badge-success px-3 py-3 ml-2">Booking Completed</span>}

                                                {((userCatalogOrdersDisputes && userCatalogOrdersDisputes.status === 0)) && <div>
                                                    <span className="badge badge-danger px-3 py-3 mb-2">Booking Disputed</span> <br />
                                                    <b>Reason:</b> {userCatalogOrdersDisputes && userCatalogOrdersDisputes.description}
                                                </div>}
                                                {(parseInt(item && item.status) === orderStatus.ORDER_CANCELLED) && <span className="badge badge-danger px-3 py-3 ml-2">Booking Cancelled</span>}

                                            </div>
                                            
                                            <div className="review">
                                                {showRating &&
                                                <button type="button" className="btn btn-outline-primary" onClick={() => this.setState({ratingOpen : true})}>Write Review</button>}
                                                {showCancel && <button type="button" className="btn btn-outline-primary" onClick={() => this.setState({cancelOpen : true})}>Cancel Booking</button>}

                                                {(differTime <= (12*3600) && differTime > 0 && item.status !== orderStatus.ORDER_COMPLETE && item.status !== orderStatus.ORDER_DISPUTE) && <p>Session can't cancelled before 12 hours of booking time.</p>}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-12 mt-3">
                                        <h6>Child Details</h6>
                                        <p className="d-flex">
                                            <span className="mr-3"><b>Name:</b> {orders && orders.child && orders.child.name}</span>
                                            <span><b>Grade:</b> {orders && orders.child && orders.child.grade}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="msg-right">
                    {activeKey && <Messenger activeKey={activeKey} profile={tutor && tutor}/>}
                </div>
            </section>
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(UserBookingView);